module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzEwMHB4JyB3aWR0aD0nMTAwcHgnICBmaWxsPSIjQTJBMkEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgeD0iMHB4IiB5PSIwcHgiPjxnIGRhdGEtbmFtZT0iTGF5ZXIgODkiPjxwYXRoIGQ9Ik00OS41MywzMC40OWwtMzIuNDQtMjhBMiwyLDAsMCwwLDEzLjc4LDRWNjBhMiwyLDAsMCwwLDMuMzEsMS41MWwzMi40NC0yOEEyLDIsMCwwLDAsNDkuNTMsMzAuNDlaIj48L3BhdGg+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/right-caret.svg
// module id = 1080
// module chunks = 33